import React, { useState, useEffect, useRef } from 'react';
import { useForm } from "react-hook-form";
import { collection, collectionGroup,  query, where,  getDocs} from "firebase/firestore"; 
import { db } from "../firebase-config";
import Financeurs from "./Financeurs";
import {AiOutlineInfoCircle} from "react-icons/ai";
import {CiFaceFrown} from "react-icons/ci";
import {IoMdSearch} from "react-icons/io";
import { VscChromeClose } from 'react-icons/vsc'
import { Link } from 'react-router-dom';
import Offer from './Offer';
import Filtered from './Filtered';

const MurDesOffres = () => {

    const [offer, setOffer] = useState([])
    const [searchOn, setSearchOn] = useState(false)
    const [search, setSearch] = useState(false)
    const formRef = useRef()
    const [intitule, setIntitule] = useState("")
  
    const [isEmpty, setIsEmpty] = useState("")
    const [modal, setModal] = useState(false)
    const [filteredArr, setFilteredArr] = useState([])
    const [intituleArr, setIntituleArr] = useState([])
 
    console.log(offer);
    const handleSuggest = async (e) => {
       setSearch(e.target.value)
       setFilteredArr(offer.filter(item => item.INTITULE.toLowerCase().includes(search.toLowerCase())))
        if(filteredArr.length > 1) {
            setSearchOn(true)
        }
        if(filteredArr.length === 0) {
            setIsEmpty(true)
        } else {
            setIsEmpty(false)
        }
    }

    console.log(search)

    console.log(filteredArr);

    console.log(isEmpty);


    useEffect(() =>  {
        setOffer([]);
        loadOfferData();
    }, []);

    const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
        mode: 'onChange',
        defaultValues: "",
  })

    const loadOfferData = async () =>  {
  
  
        const ref = collection(db, 'offreDemploi');
        const querySnapshot = await getDocs(ref)
        querySnapshot.forEach((doc) => {
         
            setOffer(offer => [doc.data(), ...offer])
            
        }) 
    
    }

    const onSubmit = async data  => {


 

    try {
        console.log(offer);
        setSearch(data.intitule)
      

  

      }
              catch(err) {
              console.log(err);
           

          }
      
          formRef.current.reset();
       
          
}
    return (
        <div>


            <form className="" ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                <label>Chercher une offre</label>
                <div className="search">
                <input minLength={1} required onKeyUp={handleSuggest} {...register('intitule')} type="text" />
                 <button id="submit"><IoMdSearch/></button>
                </div>
            </form>
         
           
            
            <div>
        

            <div className="container">
            {searchOn === true ? filteredArr.sort((a, b) => a.INTITULE.localeCompare(b.INTITULE)).map( item => (
                <Filtered key={item.INTITULE + item.ID} item={item} filtered={filteredArr} close={<VscChromeClose />} searchOn={searchOn}/>
                )) : 
                offer.sort((a, b) => a.INTITULE.localeCompare(b.INTITULE)).map( item => (
                    <Offer key={item.INTITULE + item.ID} item={item} close={<VscChromeClose />} searchOn={searchOn}/>
                    ))
                }
                {isEmpty && <div className="empty"><p>Vide</p> <CiFaceFrown/></div>}
            </div> 
             </div>
         
          
        </div>
    )
};

export default MurDesOffres;